import React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel, Checkbox, FormGroup } from '@mui/material';

const CheckboxFormField = ({
  label,
  className,
  ...rest
}) => {
  return (
    <FormGroup className={className}>
      <FormControlLabel
        control={
          <Checkbox
            inputProps={{ 'aria-label': 'controlled' }}
            {...rest}
          />
        }
        label={label}
      />
    </FormGroup>
  );
}

CheckboxFormField.propTypes = {
  label: PropTypes.node,
  className: PropTypes.string
};


CheckboxFormField.defaultProps = {
  label: undefined,
};

export default CheckboxFormField;
